// ABOUTME: Explicit action-capture API for confirms that happen outside a marked DOM click.
// ABOUTME: Enqueues an 'action' event on the current route; a no-op while analytics is off.

import { enqueueAnalyticsEvent, getCurrentRoute } from './analyticsQueue';

export function trackAction(name: string, properties?: Record<string, unknown>) {
    try {
        const { routePattern, path } = getCurrentRoute();
        enqueueAnalyticsEvent({
            eventType: 'action',
            name,
            routePattern,
            path: path ?? window.location.pathname,
            properties,
            occurredAt: new Date().toISOString(),
        });
    } catch {
        // Capture never throws into the app.
    }
}
